<template>
  <div>
    <Head :title="prodi.nama" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/universities/${university.id}/prodis`">Data Prodi</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ prodi.nama }}
    </h1>
    <div class="w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.nama" :error="form.errors.nama" class="pb-8 pr-6 w-full lg:w-1/2" label="Nama Prodi" />
          <text-input v-model="form.kode_prodi" :error="form.errors.kode_prodi" class="pb-8 pr-6 w-full lg:w-1/2" label="Kode Prodi" />
          <select-input v-model="form.jenjang" :error="form.errors.jenjang" class="pb-8 pr-6 w-full lg:w-1/2" label="Jenjang">
            <option value="S1">S1 - Sarjana</option>
            <option value="D4">D4 - Diploma 4</option>
            <option value="D3">D3 - Diploma 3</option>
          </select-input>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link class="btn-red" :href="`/universities/${university.id}/prodis?search=${prodi.nama}`">
            <font-awesome-icon class="mr-2" icon="fas fa-arrow-left" />Kembali
          </Link>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '../../../Shared/SelectInput.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  props: {
    university: Object,
    prodi: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nama: this.prodi.nama,
        kode_prodi: this.prodi.kode_prodi,
        jenjang: this.prodi.jenjang,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/universities/${this.university.id}/prodis/${this.prodi.id}`)
    },
  },
}
</script>
